export default __webpack_public_path__ + "static/media/cardbg.aeb4fc90.png";